// AI健康
const antRoutes = Array.from({ length: 22 }, (_, i) => ({
  path: `AIHealth/ant/index${i + 1}`,
  name: `AIHealth/ant/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIHealth/ant/index${i + 1}.vue`)
}))




import AIHealthIndex from '@/views/smartLife/AIHealth/index'



export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'AIHealth/index',
        name: 'AIHealthIndex',
        component: AIHealthIndex
      },
    // AI蚂蚁阿福，开始
    ...antRoutes,
    // AI蚂蚁阿福，结束


  ],
};
